<script setup>
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { CursorArrowRaysIcon } from "@heroicons/vue/20/solid";
import AppLink from "@Components/AppLink.vue";
import { WordPressPageIcon, WordPressPostIcon } from "@Icons/index";

const { t: __ } = useI18n();
const route = useRoute();

const navigation = [
    { icon: WordPressPostIcon, name: __("Articles"), href: { name: "linking.automatic.posts" }, match: "^linking.automatic.posts" },
    { icon: WordPressPageIcon, name: __("Pages"), href: { name: "linking.automatic.pages" }, match: "^linking.automatic.pages" },
    { icon: CursorArrowRaysIcon, name: __("Automatique"), href: { name: "linking.manual.index" }, match: "^linking.manual" },
];

const current = (match) => {
    if (match !== undefined) {
        return route.name.match(new RegExp(match)) !== null;
    }

    return false;
};
</script>

<template>
    <div class="min-h-screen flex flex-col xl:flex-row">
        <div class="flex-none bg-white dark:bg-gray-900 xl:w-64 xl:py-8 xl:border-r xl:border-gray-300 xl:dark:border-gray-800">
            <nav class="w-full">
                <ul role="list" class="flex xl:flex-col xl:space-y-1">
                    <li v-for="item in navigation" :key="item.name">
                        <AppLink
                            :to="item.href"
                            :target="item.target"
                            :current="current(item.match)"
                            :class="[
                                current(item.match)
                                    ? 'border-gray-950 bg-gray-50 dark:bg-gray-800 dark:border-gray-600'
                                    : 'hover:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:border-gray-700 border-transparent',
                                'text-gray-900 dark:text-gray-200 group flex flex-col sm:flex-row items-center gap-x-1.5 px-6 py-2 text-sm leading-6 border-l-2',
                            ]">
                            <component
                                :is="item.icon"
                                :class="[current(item.match) ? 'text-gray-950 dark:text-white' : '', 'w-6 h-6 shrink-0']"
                                aria-hidden="true" />
                            <div>{{ item.name }}</div>
                        </AppLink>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="flex-1">
            <slot></slot>
        </div>
    </div>
</template>
